import { render, staticRenderFns } from "./emptyLanguages.vue?vue&type=template&id=3f96e8ff&scoped=true&"
import script from "./emptyLanguages.vue?vue&type=script&lang=js&"
export * from "./emptyLanguages.vue?vue&type=script&lang=js&"
import style0 from "./emptyLanguages.vue?vue&type=style&index=0&id=3f96e8ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96e8ff",
  null
  
)

export default component.exports